<template>
  <div class="container_position">
    <el-card class="box-card" style="padding-left: 12px;padding-right: 12px">
      <el-row :gutter="24">
        <el-col :span="8">
          <div class="grid-content bg-purple position_text">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>{{$store.state.bread.oB}}</el-breadcrumb-item>
              <template v-for="item in $store.state.bread.children" v-if="$store.state.bread.topPath!=1&&$store.state.bread.topPath!=7&&$store.state.bread.topPath!=8">
                <el-breadcrumb-item>{{item.name}}</el-breadcrumb-item>
              </template>
            </el-breadcrumb>
          </div>
        </el-col>
        <el-col :span="8" :offset="8">
          <div class="grid-content bg-purple prve_login_time">
            上次登录：{{time}}
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  import { base64 } from '@/utils'
  export default {
    data() {
      return {
        time: ''
      }
    },
    methods: {
      _setLastTime() {
        let info = this.$store.state.userInfo
        this.time = info.jfUser ? info.jfUser.lastLoginTime : info.lastLoginTime
      }
    },
    mounted() {
      this._setLastTime()
    }
  }
</script>

<style lang="scss">
  @import '~scss/common/position.scss';
</style>


// WEBPACK FOOTER //
// src/views/common/position.vue